import {Component, signal, computed, OnDestroy} from '@angular/core';
import {UserDetailsStore} from '@stores/user-details.store';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'cloudlab-complete-profile-step1',
  templateUrl: './cloudlab-complete-profile-step1.component.html',
  styleUrls: ['./cloudlab-complete-profile-step.component.scss'],
  imports: [MatIconModule, MatButtonModule, TranslateModule],
})
export class CloudlabCompleteProfileStep1Component implements OnDestroy {
  selectedJobTitles = signal<string[]>([]);
  school = signal('');

  isValid = computed(() => this.selectedJobTitles().length > 0);

  jobTitleOptions = [
    {key: 'classroomTeacher', label: 'complete-profile.classroomTeacher'},
    {
      key: 'schoolOrDistrictAdmin',
      label: 'complete-profile.schoolOrDistrictAdmin',
    },
    {key: 'homeschoolEducator', label: 'complete-profile.homeschoolEducator'},
    {key: 'otherNA', label: 'complete-profile.otherNA'},
  ];

  constructor(private userDetailsStore: UserDetailsStore) {
    const state = this.userDetailsStore.state();
    this.selectedJobTitles.set([...(state.jobTitles || [])]);
    this.school.set(state.school || '');
  }

  ngOnDestroy() {
    this.saveToStore();
  }

  toggleJobTitle(key: string) {
    this.selectedJobTitles.update((current) => {
      const index = current.indexOf(key);
      return index >= 0
        ? current.filter((_, i) => i !== index)
        : [...current, key];
    });

    if (
      key === 'homeschoolEducator' &&
      this.selectedJobTitles().includes('homeschoolEducator')
    ) {
      this.school.set('Homeschool');
    } else if (
      key === 'otherNA' &&
      this.selectedJobTitles().includes('otherNA')
    ) {
      this.school.set('Other / NA');
    }
    this.saveToStore();
  }

  isJobTitleSelected(key: string): boolean {
    return this.selectedJobTitles().includes(key);
  }

  saveToStore() {
    this.userDetailsStore.setJobTitles([...this.selectedJobTitles()]);
    this.userDetailsStore.setSchool(this.school());
  }
}
